module.exports = __webpack_public_path__ + "static/img/bmw_bluetooth_2_1.835ab8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/bmw_bluetooth_2_1.png
// module id = 5vxX
// module chunks = 215